export default "__VITE_ASSET__1dbc644a__"